import * as React from 'react';
import { QuestionPreview } from '../types';
import { paths } from 'config/path_helpers';
import style from '../style.module.scss';
import cx from 'classnames';

interface QuestionSampleProps {
  questions: QuestionPreview[];
}

export default function QuestionSamples(props: QuestionSampleProps) {
  const { questions } = props;
  return (
    <div className={style.sampleBox}>
      <div className={style.sampleDescription}>
        <p>
          <strong>Try It</strong>
        </p>
        <p>Answer a quick practice question and review the explanation.</p>
      </div>
      <div>
        <div className={style.itemPreviews}>
          {renderQuestionPreview(questions[0])}
          {renderQuestionPreview(questions[1])}
        </div>
        <div className={style.itemPreviews}>
          {renderQuestionPreview(questions[2])}
          {renderQuestionPreview(questions[3])}
        </div>
      </div>
    </div>
  );
}

function renderQuestionPreview(question: QuestionPreview) {
  return (
    <a
      className={cx('btn btn-multi-line btn-default', style.itemPreview)}
      href={paths.tourPrompt(question.promptId, 1)}
      key={question.promptId}>
      <p>
        <strong>{question.examSection}</strong>
      </p>
      <p className={style.subtitle}>{question.subject}</p>
    </a>
  );
}
